/**
 * Created by Bart Decorte
 * Date: 2019-08-26
 * Time: 17:10
 */

const BlockElementDrag = (BlockElementDrag = class {}) =>
  class extends BlockElementDrag {
    constructor(params = {}) {
      super(params);
      this.$root = this.$root || params.$root;
      this.ignoreSelector = params.ignoreSelector;
      this.sortFrom = undefined;
      this.$sortedTile = undefined;
      this.$wrap = this.$root.find('.js-sort-wrap').first();
      this.initElementDrag();
    }

    initElementDrag() {
      const scope = this;

      if (!this.$wrap.is('[data-sortable="1"]')) {
        return this;
      }

      const sortableConfig = {
        start: (ev, ui) => {
          scope.start(ev, ui);
        },
        stop: (ev, ui) => {
          scope.stop(ev, ui);
        },
        cancel:
          'input, textarea, button, select, option, .cke, .cke *, .modal-image-settings, .modal-image-settings *, .dropdown-menu, .dropdown-menu *, .map',
      };

      if (typeof this.ignoreSelector !== typeof undefined) {
        sortableConfig['items'] = `> *:not(${this.ignoreSelector})`;
      }

      this.$wrap.sortable(sortableConfig);
      return this;
    }

    start(ev, ui) {
      this.sortFrom = this.elementDragPosition(ui.item);
    }

    stop(ev, ui) {
      const to = this.elementDragPosition(ui.item);
      if (this.sortFrom != to) {
        const adjusted = this.adjustForDescendingSort(this.sortFrom, to);
        this.updateSort(adjusted.from, adjusted.to);
      }
    }

    elementDragPosition($tile) {
      let $siblings = $tile
        .parent()
        .children()
        .not('.ui-sortable-placeholder');
      if (typeof this.ignoreSelector !== typeof undefined) {
        $siblings = $siblings.not(this.ignoreSelector);
      }
      return $siblings.index($tile);
    }

    entryCount() {
      return this.$wrap.find(`> *:not(${this.ignoreSelector})`).length;
    }

    isDescendingSort() {
      return this.$wrap.is('[data-sort-direction="DESC"]');
    }
  };

export default BlockElementDrag;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/BlockElementDrag.js